import { defineStore } from 'pinia'
import ResultSharingService from 'src/services/shareableLink'
import { ref } from 'vue'

const urlParams = new URLSearchParams(window.location.search)

export const useResultSharingLinkStore = defineStore('shareableLink', () => {
  const token = ref(urlParams.get('token'))
  const isShareableTokenUser = ref(Boolean(urlParams.get('token')))
  const isTokenAccessVerified = ref(false)
  const accessPassword = ref('')
  const isPasswordRequired = ref(urlParams.get('password_required') === 'true')

  const generateToken = async (params) => {
    const [error, data] = await ResultSharingService.getShareableToken(params)
    if (error) return error

    if (data?.token) {
      token.value = data.token
      isPasswordRequired.value = !data.warning
      return data.token
    }
  }

  const verifyTokenAccess = async (params) => {
    const [error, data] = await ResultSharingService.verifyShareableAccess(params)
    if (error) return error

    return data
  }

  return {
    token,
    isShareableTokenUser,
    isTokenAccessVerified,
    accessPassword,
    generateToken,
    verifyTokenAccess,
    isPasswordRequired
  }
})
